module.exports = __webpack_public_path__ + "img/calapan-multimedia1.82c6d495.jpg";